import useAppStore from "@/context/store";
import { getGdUserOrgs, switchOrg } from "@/services";
import dayjs from "dayjs";

export function isGdMerged(user: IUser) {
  return Boolean(getOrgIdByUser(user)) || Boolean(user?.extra?.uc_id);
}

export function getOrgIdByUser(user: IUser) {
  return user?.extra?.org_id;
}

/**终身会员判断 */
export function isPermanentlyVip(expireDate: number | string | Date) {
  return dayjs(expireDate).diff(dayjs(), "year") > 50;
}

/**
 * 获取当前有效期文案
 * @param expireDate 过期时间
 * @returns YYYY-MM-DD 到期 / 终身有效
 */
export function getExpireDateTxt(expireDate: number | string | Date) {
  if (!expireDate) return "";

  if (new Date(expireDate).getTime() < new Date().getTime()) {
    return `会员已于 ${dayjs(expireDate).format("YYYY-MM-DD")} 到期`;
  }

  return isPermanentlyVip(expireDate)
    ? "终身有效"
    : `${dayjs(expireDate).format("YYYY-MM-DD")} 到期`;
}

// 全局变量，用于确定只会有一次处理过程
let handlePromise: Promise<boolean> = null;
/**
 * 遇到用户不在租户里的处理函数
 * 处理逻辑：查询当前用户所有租户，然后自动切换到第一个租户
 * 接口返回如下错误信息时， 做此处理：code: "10010412"  message: "用户不在租户里"
 */
export async function handleUserNotInOrg() {
  if (handlePromise) {
    return handlePromise;
  }

  async function switchFn() {
    const orgs = await getGdUserOrgs();

    if (orgs.length > 0) {
      const user = useAppStore.getState().user;
      const orgId = getOrgIdByUser(user);

      // orgId在orgs中， 则自动切换到orgId
      if (orgId && orgs.find((org) => org.org_id === orgId)) {
        const res = await switchOrg(orgId);
        // 重置变量
        handlePromise = null;

        useAppStore.getState().refreshUser();

        return !res.err;
      }

      // 自动切换到第一个组织
      const res = await switchOrg(orgs[0].org_id);
      // 重置变量
      handlePromise = null;

      useAppStore.getState().refreshUser();

      return !res.err;
    } else {
      handlePromise = null;
      // 当前用户不存在租户
      return false;
    }
  }

  handlePromise = switchFn();

  return handlePromise;
}
